import { isShown } from './isShown';
import { ConditionalLogicHelperOptions } from './types';

export const isNotShown = ({
  questionToCheck,
  questionsToKeep,
}: ConditionalLogicHelperOptions): boolean =>
  !isShown({ questionToCheck, questionsToKeep });
